module.exports = __webpack_public_path__ + "static/NeutraText-Light-68aca16f4b19d4695789a3406ca894bc.ttf";